import { Amenity, FacilityDetails, FacilityId } from '../facilities'
import { Timetable, TimetableDetails } from '../timetables'
import { Activity } from '../activities'
import { AreaId, Area } from '../areas'
import { Review, ReviewScores } from '../reviews'
import { Gender, AttentionsList, PagerParams } from '../../types'

export type ProgramId = number

export enum ProgramLevel {
  ENTRY = 1,
  BEGINNER = 2,
  INTERMEDIATE = 3,
  ADVANCED = 4,
}

export interface Belonging {
  wear: Boolean
  shoes: Boolean
  socks: Boolean
  towel: Boolean
  drink: Boolean
}

export interface Program {
  id: ProgramId
  name: string
  description: string
  level: ProgramLevel
  facility: FacilityDetails
  activities: Activity[]
  belongings: Belonging
  otherBelongings: string[]
  attention: AttentionsList
  minuteAgo: number
  duration: number
  image: string
  sexLimitation: Gender
  minimumPoint: number | null
  minTimetablePoint: number
  maxTimetablePoint: number
}

export interface ProgramWithTimetables extends Program {
  timetables: Timetable[]
}

export interface ProgramDetails extends Program {
  reviews: Review[]
  amenities: Amenity
  reviewScoreAverages: ReviewScores
  facilityReviewCount: FacilityDetails['reviewCount']
  facilityAttention: FacilityDetails['attention']
  facilityImages: FacilityDetails['images']
  hasReadAgreement: boolean
  registeredFavorite: boolean
  isOnline: boolean
}

export interface ProgramTimetableDetails extends TimetableDetails {
  programId: ProgramId
  facilityId: FacilityId
  isOnline: boolean
}

export interface ListParams extends PagerParams {
  activityIds?: number[]
  areaIds?: AreaId[]
  sexLimitation?: Gender[]
  level?: ProgramLevel[]
  searchDates?: string[]
  startTimeBefore?: string
  startTimeAfter?: string
  showFullReservations?: boolean
  isOnline?: boolean
  sortBy?: 'createdAt' | 'minTimetablePoint' | 'minTimetableStartAt'
  order?: 'asc' | 'desc'
}

export interface SearchResponse {
  activities: Activity[]
  areas: Area[]
}

export interface SearchCountParams extends ListParams {}

export interface SearchCountResponse {
  count: number
}
